// extracted by mini-css-extract-plugin
export default {"productList":"ProductList_productList__D2LgU","productListContainer":"ProductList_productListContainer__DDKsV"};